var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.event && _vm.event.event_date
    ? _c(
        "div",
        {
          staticClass: "social-event-tile",
          class: _vm.event.external_event ? "external" : "internal",
        },
        [
          _c(
            "div",
            {
              staticClass: "ci-card with-hover pt-3 pb-5 w-100",
              class: _vm.withBorder ? "with-border" : "",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "social-event-tile__wrapper d-flex flex-column flex-md-row mx-5 flex-md-nowrap",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "social-event-tile__event col-12 col-md-4 p-0 pr-0 pr-md-5 pb-5 pb-md-0",
                    },
                    [
                      _vm.context === "event_page"
                        ? [
                            _c(
                              "b-carousel",
                              {
                                ref: "company-logos-list",
                                staticClass: "w-100",
                                attrs: {
                                  id: "company-logos-list",
                                  interval: 0,
                                  indicators: _vm.companyProfiles.length > 1,
                                },
                              },
                              [
                                _vm._l(_vm.companyProfiles, function (profile) {
                                  return [
                                    _c("b-carousel-slide", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "img",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "ci-router-link",
                                                  {
                                                    staticClass: "h-100 w-100",
                                                    attrs: { to: profile.link },
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "img bg-center bg-contain h-100 w-100",
                                                      style: {
                                                        backgroundImage: `url(${profile.logo})`,
                                                        minHeight: "120px",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        : [
                            _c("div", {
                              staticClass: "social-event-tile__type",
                              domProps: { textContent: _vm._s(_vm.eventType) },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "social-event-tile__date-wrapper d-flex flex-row flex-sm-column justify-content-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "social-event-tile__day" },
                                  [_vm._v(_vm._s(_vm.eventDateParts.day))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "social-event-tile__month" },
                                  [_vm._v(_vm._s(_vm.eventDateParts.month))]
                                ),
                              ]
                            ),
                          ],
                      _c(
                        "div",
                        {
                          staticClass:
                            "social-event-tile__button-container-small d-flex flex-row flex-md-column mt-3",
                          class: _vm.contextSize.buttonLeft,
                        },
                        [
                          _vm.directSignup
                            ? _c("ci-registration-button", {
                                attrs: {
                                  "wrapper-classes":
                                    "social-event-tile__button mobile register w-100",
                                  "inner-classes": "w-100",
                                  event: _vm.event,
                                  "participation-call-failed":
                                    _vm.participationCallFailed,
                                  "tracking-context": _vm.registrationContext,
                                },
                              })
                            : _vm._e(),
                          _vm.event.event_page_link
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-items-center w-100",
                                    class: {
                                      "ml-3 ml-md-0": _vm.event.external_event,
                                    },
                                  },
                                  [
                                    _c("ci-button", {
                                      staticClass:
                                        "social-event-tile__button mobile learn-more w-100 mt-0 mt-md-3",
                                      class: { "mb-2": !_vm.directSignup },
                                      attrs: {
                                        variant: "outline-primary",
                                        to: _vm.event.event_url,
                                        label: _vm.$t(
                                          "ui.components.social_events.tile.learn_more"
                                        ),
                                      },
                                    }),
                                    !_vm.directSignup
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "register-via-learn-more text-muted d-flex align-items-center text-left",
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "mdi mdi-information mr-2 mdi-18px",
                                            }),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "ui.components.social_events.tile.register_via_learn_more"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "social-event-tile__event-details-wrapper col pl-0 pl-md-5 pt-4 pt-md-0 pr-0",
                      class: _vm.contextSize.main,
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "social-event-tile__title" },
                        [
                          _vm.context === "event_page"
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "social-event-tile__type" },
                                  [_vm._v(_vm._s(_vm.eventType + " | "))]
                                ),
                              ]
                            : _vm._e(),
                          _c("span", {
                            staticClass: "text-center text-sm-left",
                            domProps: {
                              textContent: _vm._s(_vm.event.headline),
                            },
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "social-event-tile__details-row-wrapper d-flex flex-column-reverse flex-md-column",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "social-event-tile__details-row flex-wrap d-flex",
                            },
                            [
                              _vm.companyProfiles.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "social-event-tile__detail row m-0 w-100",
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "social-event-tile__icon mdi mdi-domain",
                                      }),
                                      _vm._l(
                                        _vm.companyProfiles,
                                        function (companyProfile, index) {
                                          return [
                                            _c("div", {
                                              staticClass:
                                                "social-event-tile__text",
                                              domProps: {
                                                textContent: _vm._s(
                                                  companyProfile.name
                                                ),
                                              },
                                            }),
                                            index <
                                            _vm.companyProfiles.length - 1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mx-3" },
                                                  [_vm._v("|")]
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "row mt-1 mx-0" },
                                [
                                  _vm.context === "event_page"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "social-event-tile__detail",
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "social-event-tile__icon mdi mdi-calendar",
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "social-event-tile__date-wrapper d-flex flex-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "social-event-tile__day",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.eventDateParts.day
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "social-event-tile__month",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.eventDateParts.month
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "social-event-tile__detail",
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "social-event-tile__icon mdi mdi-timer-outline",
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "social-event-tile__text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.eventDateParts.dayTime
                                                  ) +
                                                    " " +
                                                    _vm._s(_vm.$t("clock"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "social-event-tile__detail",
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "social-event-tile__icon mdi mdi-timer-outline",
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "social-event-tile__text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.eventDateParts.dayTime
                                                  ) +
                                                    " " +
                                                    _vm._s(_vm.$t("clock"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                  _vm.event.location
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "social-event-tile__detail",
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "social-event-tile__icon mdi mdi-map-marker",
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "social-event-tile__text",
                                            },
                                            [_vm._v(_vm._s(_vm.event.location))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm.event.description
                            ? _c("div", {
                                directives: [
                                  {
                                    name: "line-clamp",
                                    rawName: "v-line-clamp",
                                    value: 3,
                                    expression: "3",
                                  },
                                ],
                                staticClass:
                                  "social-event-tile__description d-none word-break-word",
                                class: _vm.contextSize.description,
                                domProps: {
                                  innerHTML: _vm._s(_vm.description),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "social-event-tile__button-container-large",
                      class: _vm.contextSize.buttonRight,
                    },
                    [
                      _vm.directSignup
                        ? _c("ci-registration-button", {
                            attrs: {
                              "wrapper-classes":
                                "social-event-tile__button register w-100",
                              "inner-classes": "w-100",
                              event: _vm.event,
                              "participation-call-failed":
                                _vm.participationCallFailed,
                              "tracking-context": _vm.registrationContext,
                            },
                          })
                        : _vm._e(),
                      _vm.event.event_page_link
                        ? [
                            _c("ci-button", {
                              staticClass:
                                "social-event-tile__button learn-more w-100 mt-3",
                              class: { "mb-2": !_vm.directSignup },
                              attrs: {
                                variant: "outline-primary",
                                to: _vm.event.event_url,
                                label: _vm.$t(
                                  "ui.components.social_events.tile.learn_more"
                                ),
                              },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.$emit("tracking-click", {
                                    targetName: "Event",
                                    targetId: _vm.event.id.toString(),
                                  })
                                },
                              },
                            }),
                            !_vm.directSignup
                              ? _c(
                                  "small",
                                  {
                                    staticClass:
                                      "register-via-learn-more text-muted d-flex align-items-center text-left",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "mdi mdi-information mr-2 mdi-18px",
                                    }),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "ui.components.social_events.tile.register_via_learn_more"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }